"use client";

import { useLocale, useTranslations } from "next-intl";
// import { unstable_setRequestLocale } from "next-intl/server";
import Image from "next/image";
import React, { FC } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";

// TODO ask Fra why
// export const dynamic = "force-dynamic";

export default function NotFound() {
  const t = useTranslations();
  const locale = useLocale();
  const logoImage = locale.includes("ar") ? "damac_logo_arabic.svg" : "DAMAC_DIGITAL_LOGO_WHITE.svg";
  return (
    <div className="bg-black text-white min-h-screen flex flex-col justify-center items-center gap-xl text-center">
      <Image src={`/assets/${logoImage}`} width={169} height={21} alt="Damac Digital" />
      <p dangerouslySetInnerHTML={{ __html: t("page.notFound") }} />
      <Button href={"/"} size={ButtonSize.MEDIUM} variant={ButtonVariant.PRIMARY} theme={ButtonTheme.WHITE}>
        {t("button.label.homepage")}
      </Button>
    </div>
  );
}
